import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

// 0000200135 → 200135
const stripLeadingZeros = (value) => {
    if (value === null || value === undefined) return '';
    return String(value).replace(/^0+/, '') || '0';
};

const kunnrBodyTemplate = (rowData) => stripLeadingZeros(rowData.kunnr);

const formatPrice = (value) => (value == null ? '-' : Number(value).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

const MaterialCatalogDetailTable = ({ items, lazyParams, totalRecords, loading, onPage, th, isDealer }) => {
    return (
        <DataTable
            value={items}
            lazy
            paginator
            first={lazyParams.first}
            rows={lazyParams.rows}
            onPage={onPage}
            totalRecords={totalRecords}
            loading={loading}
            emptyMessage={th('common.noData')}
            rowsPerPageOptions={[5, 10, 25, 50]}
            showGridlines
            stripedRows
            tableStyle={{ minWidth: '60rem' }}
        >
          {!isDealer && (
                <Column
                    field="kunnr"
                    header={th('materialCatalog.kunnr')}
                    body={kunnrBodyTemplate}
                    style={{ minWidth: '120px' }}
                />
            )}
            <Column field="partCode" header={th('materialCatalog.partCode')} body={(rowData) => rowData.partCode ?? '-'} style={{ minWidth: '150px' }} />
            <Column field="partDescription" header={th('materialCatalog.partDescription')} body={(rowData) => rowData.partDescription ?? '-'} style={{ minWidth: '200px' }} />
            <Column field="retailPrice" header={th('materialCatalog.retailPrice')} body={(rowData) => formatPrice(rowData.retailPrice)} style={{ minWidth: '150px' }} />
            <Column field="vatIncludedPrice" header={th('materialCatalog.vatIncludedPrice')} body={(rowData) => formatPrice(rowData.vatIncludedPrice)} style={{ minWidth: '150px' }} />
            <Column field="currency" header={th('materialCatalog.currency')} body={(rowData) => rowData.currency ?? '-'} style={{ minWidth: '100px' }} />
            <Column field="stockQuantity" header={th('materialCatalog.stockQuantity')} body={(rowData) => rowData.stockQuantity ?? '-'} style={{ minWidth: '120px' }} />
            <Column field="unit" header={th('materialCatalog.unit')} body={(rowData) => rowData.unit ?? '-'} style={{ minWidth: '100px' }} />
            <Column field="brand" header={th('materialCatalog.brand')} body={(rowData) => rowData.brand ?? '-'} style={{ minWidth: '120px' }} />
            <Column field="block" header={th('materialCatalog.block')} body={(rowData) => rowData.block ?? '-'} style={{ minWidth: '100px' }} />
            <Column field="shelf" header={th('materialCatalog.shelf')} body={(rowData) => rowData.shelf ?? '-'} style={{ minWidth: '100px' }} />
            <Column field="row" header={th('materialCatalog.row')} body={(rowData) => rowData.row ?? '-'} style={{ minWidth: '80px' }} />
            <Column field="slot" header={th('materialCatalog.slot')} body={(rowData) => rowData.slot ?? '-'} style={{ minWidth: '80px' }} />
        </DataTable>
    );
};

export default MaterialCatalogDetailTable;
